module.exports = __webpack_public_path__ + "static/media/bankThumbnail.9df89ecd.png";